import script from "./productDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./productDetails.vue?vue&type=script&setup=true&lang=js"

import "./productDetails.vue?vue&type=style&index=0&id=102bae61&scoped=true&lang=css"

import exportComponent from "C:\\Users\\liuqi\\Desktop\\R\\website-vue3-antd\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-102bae61"]])

export default __exports__